import { render } from "./Modal.vue?vue&type=template&id=e97860c4"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alejandropascual/Websites/_CODEABLE/Task-171603-Beat/wordpress/wp-content/plugins/aps-modul-booking/_vue/shortcode_modul_courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__